function e(t) {
  return t;
}
var i = e;
export {
  i as default
};
//# sourceMappingURL=identity.js.map
